export default class FVisitorFilter {
  constructor(
      id = 0,
      pageNo= 0,
      pageSize = 0,
      sortBy="id",
      order="DESC",
      search="",

      dateFrom= new Date(),
      dateTo = new Date(),


  ) {
    this.id = id;
    this.pageNo = pageNo;
    this.pageSize = pageSize;
    this.sortBy = sortBy;
    this.order = order;
    this.search = search;

    this.dateFrom = dateFrom;
    this.dateTo = dateTo;

  }

}
